import * as React from 'react';

import type * as api from '@gitbook/api-client';
import { assertNever } from '@gitbook/util-ts';

export enum FLOW_STEPS {
    CREATE_ORGANIZATION = 'create-organization',

    // redirect step
    COMPLETE = 'complete',
}

type StateCreateOrg = {
    step: FLOW_STEPS.CREATE_ORGANIZATION;
};

type StateComplete = {
    step: FLOW_STEPS.COMPLETE;
    context: {
        organization: api.Organization;
        site: api.Site;
        hasBootstrappedContent?: boolean;
    };
};

type State = StateCreateOrg | StateComplete;

type Action =
    | { step: FLOW_STEPS.CREATE_ORGANIZATION }
    | { step: FLOW_STEPS.COMPLETE; context: StateComplete['context'] };

/**
 * Reducer to keep state of the current step in the flow and the needed context for each step
 */
const reducer = (_: State, action: Action): State => {
    const { step } = action;
    switch (step) {
        case FLOW_STEPS.CREATE_ORGANIZATION:
            return {
                step: FLOW_STEPS.CREATE_ORGANIZATION,
            };
        case FLOW_STEPS.COMPLETE:
            return {
                step: FLOW_STEPS.COMPLETE,
                context: {
                    ...action.context,
                },
            };
        default:
            return assertNever(step);
    }
};

/**
 * Keep the state of the flow and initializes the flow
 */
export function useFlowContext(initialState?: State) {
    const [state, dispatch] = React.useReducer(
        reducer,
        initialState ?? {
            step: FLOW_STEPS.CREATE_ORGANIZATION,
        }
    );

    return [state, dispatch] as const;
}
